import React, {lazy, Suspense, useEffect, useMemo, useRef, useState} from "react";
import {ShopperHeader} from "../../components/header";
import {useDispatch, useSelector} from "react-redux";
import {IAppState} from "../../store/models";
import {zoomIn} from "../../store/actionsCreator/zoomActionCreators";
import {
    toggleFrameClickPopup,
    toggleFullscreen,
    toggleMultipage
} from "../../store/actionsCreator/controlsActionsCreator";
import {Settings} from "react-slick";
import {changeCarouselActiveSlide} from "../../store/actionsCreator/carouselActionsCreator";
import Arrow from "../../components/arrow";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {removeSelectedSpot} from "../../store/actionsCreator/selectedSpotActionsCreator";
import {IFlyerRuntimePage, ParamTypesDto} from "../../dtos/flyer";
import {Box, Tooltip, Zoom} from "@mui/material";
import {isMobile} from "react-device-detect";
import {makeStyles} from "@mui/styles";
import {
    calculateCorrectPageFromShareLink,
    getConvertedPageNumberToSlideNumber,
    scrollToPageForFlyer
} from "../../com/globalsFunctions/globalFunctions";
// import PoweredBy from "../../components/poweredby";
import PowerByTooltipContent from "../../components/poweredby/powerByTooltipContent";
// import ProgressBarPopup from "../../com/progressBarPopup/progressBarPopup";
// import ReduxErrorHandler from "../../components/reduxErrorHandler/reduxErrorHandler";
import ShelvesScreen from "../../components/shelvesScreen/shelvesScreen";
import {useHistory, useParams} from "react-router-dom";
import {toggleDetailsAction} from "../../store/actionsCreator/detailsActionsCreator";
import {setAddToMyListOneItemData} from "../../store/actionsCreator/addToMyListOneItemActionsCreator";
import SliderFor2Flyer from "../../components/main/SliderFor2Flyer/SilderFor2pages";

const PoweredBy = lazy(() => import("../../components/poweredby"));
const Checkout = lazy(() => import("../../components/checkout"));
const HelpMenu = lazy(() => import("../../components/helppopup/helpmenu"));
const TocMenu = lazy(() => import("../../components/tocpopup/tocmenu"));
const SearchMenu = lazy(() => import("../../com/searchMenu"));
const Basket = lazy(() => import("../../components/basket"));
const AddToBasket = lazy(() => import("../../components/addtobasket"));
const ProductDetails = lazy(() => import("../../components/details"));
// const SliderFor2Flyer = lazy(() => import("../../components/main/SliderFor2Flyer/SilderFor2pages"));
// const ShelvesScreen = lazy(() => import("../../components/shelvesScreen/shelvesScreen"));
const ShareMenu = lazy(() => import("../../components/sharePopup/shareMenu"));
const FrameClickPopup = lazy(() => import("../../components/frameClickPopup/frameClickPopup"));
const AddToMyListOneItemPopupWrapper = lazy(() => import("../../components/addToMyListOneItemPopup/addToMyListOneItemPopupWrapper"));
// const PowerByTooltipContent = lazy(() => import("../../components/poweredby/powerByTooltipContent"));
const ContactUsFormWrapper = lazy(() => import("../../components/contactUs/contactUsFormWrapper"));
const ContactUsSuccessPopup = lazy(() => import("../../components/contactUs/contactUsSuccessPopup"));
const FeedbackModal = lazy(() => import("../../components/feedbackPopup/feedbackModal"));
const FreeFlipbookModal = lazy(() => import("../../components/freeFlipbokkPopup/freeFlipbookModal"));
const ProgressBarPopup = lazy(() => import("../../com/progressBarPopup/progressBarPopup"));


const useStyles = makeStyles(() => ({
    myListWrapper: (props: any) => ({
        position: `fixed`,
        right: props.direction === `rtl` ? `auto` : `0`,
        left: props.direction === `rtl` ? `0` : `auto`,
        top: `60px`,
        zIndex: 3,
        direction: props.direction,
    }),
    powerByWrapper: {
        position: `absolute`,
        bottom: `20px`,
        zIndex: 1,
        // cursor: `pointer`
        // minWidth: `178px`,
    },
    backgroundImage: (props: any) => ({
        backgroundImage: props.backgroundImage ? `url('${props.backgroundImage}')` : `none`,
        backgroundPosition: `center`,
        backgroundRepeat: `no-repeat`,
        backgroundSize: `cover`,
    }),
    backgroundColor: (props: any) => ({
        backgroundColor: props.backgroundColor ? props.backgroundColor : `white`
    })
}))


const DesktopView = () => {
    // console.log(`desktop view`);
    // const TocTitle = FindCurrentTranslateLabel(187, 'Table Of Contents')

    const dispatch = useDispatch();
    // const sliderRef = useRef(null);
    const {
        controlsBranch,
        flyersBranch,
        shelvesScreen,
        selectedSpot,
        detailsBranch,
        addToMyListOneItemData
    } = useSelector((state: IAppState) => state);
    const {
        isMultipage,
        showSearch,
        showBasket,
        isFullScreen,
        isHelpScreen,
        isTocOpen,
        shareMenu,
        frameClickPopup
    } = controlsBranch;
    const {data: flyers} = flyersBranch;
    const isHebrewStyle = flyers?.dir === "RTL";
    // const isVerticalScrolling = true;
    // const isOnePageOrientation: boolean = false;
    const isVerticalScrolling = flyersBranch.data?.pageLayoutPc === 2 || flyersBranch.data?.pageLayoutPc === 3;
    const isOnePageOrientation: boolean = flyersBranch.data?.pageLayoutPc === 3 || flyersBranch.data?.pageLayoutPc === 4;
    const contentFlyerPagesRef = useRef(null);
    const flyerContentWrapper = useRef<HTMLDivElement>(null);
    const sliderRef = useRef(null);
    let history = useHistory();
    // const isMobile = useMediaQuery("(max-width:767px)", { noSsr: true });

    const resetZooming = () => {
        dispatch(zoomIn({x: 0, y: 0, pivotX: 0, pivotY: 0, scale: 0}));
    }
    // if(!isMobile){
    //     dispatch(toggleMultipage())
    // }
    if (isMobile && isMultipage) {
        dispatch(toggleMultipage())
    }
    // const {currentSlide} = useSelector((state: IAppState) => state.carouselBranch);
    const {accountName, flyerName, pageNumber} = useParams<ParamTypesDto>();
    //get lowest number in URL pages range
    const pageStringToNumberIndex = useMemo(() => calculateCorrectPageFromShareLink(pageNumber), [pageNumber]);
    //convert page number to slide number
    const currentSlideNumber = useMemo(() => getConvertedPageNumberToSlideNumber(pageStringToNumberIndex, isMobile || isOnePageOrientation, (isHebrewStyle && !isVerticalScrolling && !isMobile), flyers?.pages)
        , [pageStringToNumberIndex, isMobile, isVerticalScrolling, isOnePageOrientation, isHebrewStyle, flyers?.pages.length]);

    const [pages, setPages] = useState<IFlyerRuntimePage[]>(flyers?.pages || []);
    const settings: Settings = {
        dots: false,
        infinite: false,
        swipe: false,
        arrows: !isFullScreen,
        slidesToShow: 1,
        waitForAnimate: false,
        adaptiveHeight: false,
        speed: 200,
        lazyLoad: "ondemand",
        initialSlide: currentSlideNumber,
        slidesToScroll: 1,
        nextArrow: <Arrow arrow='right' isHebrewStyle={isHebrewStyle} sliderRef={sliderRef}/>,
        prevArrow: <Arrow arrow='left' isHebrewStyle={isHebrewStyle} sliderRef={sliderRef}/>,
    };

    const {height: windowHeight, width: windowWidth} = useWindowDimensions();
    const stylesProperties = {
        direction: flyers?.dir.toLowerCase(),
        backgroundImage: flyers?.backgroundImage,
        backgroundColor: flyers?.backgroundColorRgb
    }
    const classes = useStyles(stylesProperties);
    const [isSuccessPopupShow, showSuccessPopup] = useState<boolean>(false);

    /*
        useEffect(() => {
            if (emailToXCSalesMarketing.type === 'SEND_EMAIL_TO_XC_SALES_SUCCESS') {
                showSuccessPopup(true);
            }
        }, [emailToXCSalesMarketing.type])
    */

    useEffect(() => {
        let isApiSubscribed = true;
        setPageRangeInUrl(currentSlideNumber);
        document.documentElement.addEventListener('fullscreenchange', fullScreenChange);
        return () => {
            isApiSubscribed = false;
            document.documentElement.removeEventListener('fullscreenchange', fullScreenChange);
        }
    }, []);

    useEffect(() => {
        setPages(flyers?.pages || []);
    }, [flyers?.pages.length])

    // useEffect(() => {
    //     if (!showThumbnails && isMobile) {
    //         const selector: any = document.querySelector("[tabindex='" + scrollBranch.pageIndex + "']");
    //         let offsetY = 0;
    //         if (selector) {
    //             offsetY = selector.offsetTop;
    //         }
    //         dispatch(scrollToSelector({x: 0, y: offsetY, pageIndex: scrollBranch.pageIndex}));
    //     }
    // }, [showThumbnails])

    useEffect(() => {
        if (!isVerticalScrolling && isFullScreen) {
            const carouselInterval = setInterval(() => {
                if (flyers && isFullScreen && sliderRef && sliderRef.current) {
                    if (!isHebrewStyle) {
                        if (!isOnePageOrientation) {
                            (sliderRef.current as any).slickGoTo(currentSlideNumber >= Math.floor(flyers.pages.length / 2) ? 0 : currentSlideNumber + 1);
                            // dispatch(changeCarouselActiveSlide(currentSlideNumber >= Math.floor(flyers.pages.length / 2) ? 0 : currentSlideNumber + 1))
                        } else {
                            (sliderRef.current as any).slickGoTo(currentSlideNumber >= flyers.pages.length - 1 ? 0 : currentSlideNumber + 1);
                            // dispatch(changeCarouselActiveSlide(currentSlideNumber >= flyers.pages.length - 1 ? 0 : currentSlideNumber + 1));
                        }
                    } else {
                        if (!isOnePageOrientation) {
                            (sliderRef.current as any).slickGoTo(currentSlideNumber <= 0 ? Math.floor(flyers.pages.length / 2) : currentSlideNumber - 1);
                            // dispatch(changeCarouselActiveSlide(currentSlideNumber <= 0 ? Math.floor(flyers.pages.length / 2) : currentSlideNumber - 1))
                        } else {
                            (sliderRef.current as any).slickGoTo(currentSlideNumber <= 0 ? flyers.pages.length - 1 : currentSlideNumber - 1);
                            // dispatch(changeCarouselActiveSlide(currentSlideNumber <= 0 ? flyers.pages.length - 1 : currentSlideNumber - 1))
                        }
                    }
                }
            }, 4000);

            return () => {
                clearInterval(carouselInterval);
            }
        }
    }, [currentSlideNumber, isFullScreen, flyers])

    useEffect(() => {
        const contentContainer = contentFlyerPagesRef.current as any;
        if (contentContainer) {
            scrollToPageForFlyer(contentContainer, currentSlideNumber);
        }
    }, [contentFlyerPagesRef.current]);

    useEffect(() => {
        let isApiSubscribed = true;
        if (isVerticalScrolling && isApiSubscribed) {
            document.documentElement.addEventListener('keydown', onKeyDownArrowsOnKeyBoardForContent)
        }
        return () => {
            isApiSubscribed = false;
            if (isVerticalScrolling) {
                document.documentElement.removeEventListener('keydown', onKeyDownArrowsOnKeyBoardForContent)
            }
        }
    }, [currentSlideNumber])

    useEffect(() => {
        if (isVerticalScrolling) {
            const contentWrapper = flyerContentWrapper.current as any;
            if (contentWrapper) {
                contentWrapper.focus();
            }
        }
    }, [flyerContentWrapper, currentSlideNumber])

    useEffect(() => {
        if (isVerticalScrolling) {
            if(selectedSpot.isExpanded){
                return;
            }
            const contentContainer = document.getElementById(`mainSliderWrapper`);
            if (contentContainer) {
                scrollToPageForFlyer(contentContainer, currentSlideNumber)
            }
        }
        return () => {
            // if (isVerticalScrolling) {
            //     const contentContainer = document.getElementById(`mainSliderWrapper`);
            //     if (contentContainer) {
            //         scrollToPageForFlyer(contentContainer, currentSlideNumber)
            //     }
            // }
        }

    }, [showBasket, isHelpScreen, shareMenu.isOpen, showSearch, isTocOpen, selectedSpot.isOpen, selectedSpot.isExpanded])

    const fullScreenChange = () => {
        if (document.fullscreenElement) {
            console.log(`Element: ${document.fullscreenElement.id} entered fullscreen mode.`);
            // dispatch(toggleFullscreen());
        } else {
            console.log('Leaving full-screen mode.');
            dispatch(toggleFullscreen(false));
        }
    }

    const openFullScreen = () => {
        if (!document.fullscreenElement) {
            dispatch(toggleFullscreen(true));
            dispatch(removeSelectedSpot());
            document.documentElement.requestFullscreen();
        }
    }

    const handleSwipe = (direction: 'left' | 'right') => {
        let increaseNumber = currentSlideNumber;
        if (flyers) {
            if (direction === 'left') {
                if (flyers.pages.length - 1 > currentSlideNumber) {
                    if (isMultipage) {
                        increaseNumber += 2;
                    } else {
                        increaseNumber += 1;
                    }
                }
            } else {
                if (currentSlideNumber > 1) {
                    increaseNumber -= 1
                }
            }
        }
        dispatch(changeCarouselActiveSlide(increaseNumber));
    }

    const calculateFlyerContainerHeightWidth = (page: IFlyerRuntimePage): { height: number, width: number } => {
        if (!page) {
            return {height: 0, width: 0}
        }
        let constant;
        let height;
        let width;
        let padding = 112;
        if (isMobile) {
            constant = page.widthPx / (windowWidth - 12);
            width = windowWidth;
            height = page.heightPx / constant;
        } else if (isVerticalScrolling) {
            if (isOnePageOrientation) {
                constant = page.widthPx / (windowWidth - 12);
                width = page.widthPx <= windowWidth ? page.widthPx : windowWidth;
                height = page.widthPx <= windowWidth ? page.heightPx : page.heightPx / constant;
            } else {
                let constForRightPanel = (showBasket || isHelpScreen || shareMenu.isOpen || showSearch || isTocOpen || (Boolean(selectedSpot.spot) && !selectedSpot.isExpanded)) ? 430 : 0;
                constant = flyers?.pages.length && flyers?.pages.length <= 1 ?
                    page.widthPx / ((windowWidth - constForRightPanel) - 12) :
                    page.widthPx / ((windowWidth - constForRightPanel) / 2 - 12);
                width = flyers?.pages.length && flyers?.pages.length <= 1 ?
                    page.widthPx <= (windowWidth - constForRightPanel) ?
                        page.widthPx :
                        ((windowWidth - constForRightPanel) - 12) :
                    page.widthPx <= (windowWidth - constForRightPanel) / 2 ?
                        page.widthPx :
                        ((windowWidth - constForRightPanel) / 2 - 12);
                height = flyers?.pages.length && flyers?.pages.length <= 1 ?
                    page.widthPx <= (windowWidth - constForRightPanel) ?
                        page.heightPx :
                        page.heightPx / constant :
                    page.widthPx <= (windowWidth - constForRightPanel) / 2 ?
                        page.heightPx :
                        page.heightPx / constant;
            }
        } else {
            // height = windowHeight - padding;
            let constForRightPanel = (showBasket || isHelpScreen || shareMenu.isOpen || showSearch || isTocOpen || (Boolean(selectedSpot.spot) && !selectedSpot.isExpanded)) ? 430 : 0;
            constant = page.heightPx / (windowHeight - padding);
            width = page.widthPx / constant;
            height = page.heightPx / constant;
            if ((width * 2 + constForRightPanel + padding > windowWidth) && !isOnePageOrientation && flyers?.pages.length) {
                constant = page.widthPx / ((windowWidth - constForRightPanel - padding) / 2);
                width = page.widthPx <= (windowWidth - constForRightPanel) / 2
                    ? page.widthPx
                    : ((windowWidth - constForRightPanel - padding) / 2 );
                height = page.widthPx <= (windowWidth - constForRightPanel) / 2
                    ? page.heightPx
                    : page.heightPx / constant;
                if (flyers?.pages.length <= 1) {
                    const sizesForPage = calculateWidthAndHeightForPageContainer(width, height, constForRightPanel, padding);
                    width = sizesForPage.width;
                    height = sizesForPage.height;
                }
                if((page.pageNumber === 1 && flyers?.pages.length > 2) || (flyers?.pages.length % 2 === 0 && page.pageNumber === flyers?.pages.length && flyers?.pages.length > 2)){
                    constant = page.heightPx / (windowHeight - padding);
                    width = page.widthPx / constant;
                    height = page.heightPx / constant;
                    if((width + constForRightPanel + padding > windowWidth) && flyers?.pages.length){
                        const sizesForPage = calculateWidthAndHeightForPageContainer(width, height, constForRightPanel, padding);
                        width = sizesForPage.width;
                        height = sizesForPage.height;
                    }
                }
            }

            if(isOnePageOrientation && (width + constForRightPanel + padding > windowWidth) && flyers?.pages.length){
                const sizesForPage = calculateWidthAndHeightForPageContainer(width, height, constForRightPanel, padding);
                width = sizesForPage.width;
                height = sizesForPage.height;
            }

        }

        return {height, width};
    }

    const calculateWidthAndHeightForPageContainer = (sourceWidth: number, sourceHeight: number, constForRightPanel: number, padding: number): {width: number, height: number} => {
        const constant = sourceWidth / ((windowWidth - constForRightPanel) - padding);
        return {
            width: sourceWidth <= (windowWidth - constForRightPanel) ? sourceWidth : ((windowWidth - constForRightPanel) - padding),
            height: sourceWidth <= (windowWidth - constForRightPanel) ? sourceHeight : sourceHeight / constant
        }
    }

    const onScrollStop = () => {
        if (isVerticalScrolling && contentFlyerPagesRef.current) {
            const contentWrapper = contentFlyerPagesRef as any;
            const pages = Array.from(contentWrapper.current.children);
            pages.forEach((page: any, index: number) => {
                const pagePosition = page.getBoundingClientRect();
                if ((pagePosition.top >= 0 && pagePosition.top <= document.documentElement.clientHeight / 100 * 51) || (pagePosition.top < 0 && pagePosition.bottom >= document.documentElement.clientHeight / 100 * 51)) {
                    // if ((pagePosition.top >= 0 && pagePosition.bottom <= document.documentElement.clientHeight) || (pagePosition.top < 0 && pagePosition.bottom >= document.documentElement.clientHeight)) {
                    if (currentSlideNumber !== index) {
                        setPageRangeInUrl(index);
                        // dispatch(changeCarouselActiveSlide(index));
                    }
                }
            })
        }
    }

    // Set a timer to detect when scrolling has stopped
    let scrollTimer: number | NodeJS.Timeout | null = null;
    const handleScroll = () => {
        // Clear the previous timer
        clearTimeout(scrollTimer as number);

        // Check if the scroll position has changed since the last scroll event
        scrollTimer = setTimeout(() => {
            // Call the onScrollStop function when the timer has expired
            onScrollStop();
        }, 100);
    };

    const setPageRangeInUrl = (slideNumber: number) => {
        if (sliderRef.current && !isVerticalScrolling) {
            if (sliderRef.current) {
                //flip sound
                // exposedData.stop();
                // pageFlip();
                // (sliderRef.current as any).slickGoTo(currentSlide);
                if (!isMobile && flyersBranch.data?.pages) {
                    // const maxPagesIndex = flyersBranch.data?.pages.length - 1;
                    // let totalPageIndexAfterConvert = calculateTotalPagesForFlyer(maxPagesIndex);
                    const pagesRange = pageNumberRange(slideNumber);
                    if (Boolean(history.location.search)) {
                        history.push(`/flyer/${accountName}/${flyerName}/${pagesRange}${history.location.search}`);
                    } else {
                        history.push(`/flyer/${accountName}/${flyerName}/${pagesRange}`);
                    }
                    if (Boolean(detailsBranch)) {
                        dispatch(toggleDetailsAction());
                    }
                    if (Boolean(addToMyListOneItemData.data)) {
                        dispatch(setAddToMyListOneItemData(null));
                    }
                    // dispatch(setFramesPlayingAction({
                    //     frameIndex: -1,
                    //     pageNumber: 0
                    // }));
                    if (frameClickPopup.isOpen) {
                        dispatch(toggleFrameClickPopup(false, null, null));
                    }
                    dispatch(zoomIn({x: 0, y: 0, pivotX: 0, pivotY: 0, scale: 0}));
                }
            }
        } else {
            const pagesRange = pageNumberRange(slideNumber);
            if (Boolean(history.location.search)) {
                history.push(`/flyer/${accountName}/${flyerName}/${pagesRange}${history.location.search}`);
            } else {
                history.push(`/flyer/${accountName}/${flyerName}/${pagesRange}`);
            }
        }
    }

    const pageNumberRange = (currentSlide: number) => {
        if (isMobile || (isVerticalScrolling && isOnePageOrientation)) {
            return `${currentSlide + 1}`
        } else if (!isMobile && (isVerticalScrolling && !isOnePageOrientation)) {
            if (currentSlide === 0) {
                if(flyersBranch.data!.pages.length === 2){
                    return `${currentSlide + 1}-${flyersBranch.data!.pages.length}`;
                }
                return `${currentSlide + 1}`;
                // } else if (currentSlide * 2 === flyersBranch.data!.pages.length) {
                //     return `${currentSlide * 2}-${flyersBranch.data!.pages.length}`;
            } else if (currentSlide * 2 >= flyersBranch.data!.pages.length) {
                return `${flyersBranch.data!.pages.length}`;
            } else {
                return `${currentSlide * 2}-${currentSlide * 2 + 1}`;
            }
        } else {
            if (!isHebrewStyle) {
                if (!isOnePageOrientation) {
                    if (currentSlide === 0) {
                        if(flyersBranch.data!.pages.length === 2){
                            return `${currentSlide + 1}-${flyersBranch.data!.pages.length}`;
                        }
                        return `${currentSlide + 1}`;
                        // } else if (currentSlide * 2 === flyersBranch.data!.pages.length) {
                        //     return `${currentSlide * 2}-${flyersBranch.data!.pages.length}`;
                    } else if (currentSlide * 2 >= flyersBranch.data!.pages.length) {
                        return `${flyersBranch.data!.pages.length}`;
                    } else {
                        return `${currentSlide * 2}-${currentSlide * 2 + 1}`;
                    }
                } else {
                    if (flyersBranch.data!.pages.length === 1) {
                        return `${flyersBranch.data!.pages.length}`
                    }
                    return `${currentSlide + 1}`
                }
            } else {
                if (!isOnePageOrientation) {
                    if (flyersBranch.data!.pages.length === 1) {
                        return `${flyersBranch.data!.pages.length}`
                    } else if (flyersBranch.data!.pages.length === 2) {
                        return `${currentSlide + 1}-${flyersBranch.data!.pages.length}`;
                    } else if (currentSlide === 0 && flyersBranch.data!.pages.length === 1) {
                        return `${flyersBranch.data!.pages.length - currentSlide * 2}`;
                    } else if (currentSlide * 2 === flyersBranch.data!.pages.length) {
                        return `${(flyersBranch.data!.pages.length - currentSlide * 2) === 0 ? 1 : flyersBranch.data!.pages.length - currentSlide * 2}`;
                    } else if (currentSlide === 0 && flyersBranch.data!.pages.length % 2 !== 1) {
                        return `${flyersBranch.data!.pages.length}`;
                    } else if (currentSlide === 0 && flyersBranch.data!.pages.length % 2 === 1) {
                        return `${flyersBranch.data!.pages.length - (currentSlide * 2 + 1)}-${flyersBranch.data!.pages.length - currentSlide * 2}`;
                    } else if (flyersBranch.data!.pages.length - currentSlide * 2 === 1) {
                        return `${flyersBranch.data!.pages.length - currentSlide * 2}`;
                    } else if ((flyersBranch.data!.pages.length - currentSlide * 2) % 2 !== 0) {
                        return `${flyersBranch.data!.pages.length - (currentSlide * 2 + 1)}-${flyersBranch.data!.pages.length - currentSlide * 2}`;
                    } else {
                        return `${flyersBranch.data!.pages.length - currentSlide * 2}-${flyersBranch.data!.pages.length - currentSlide * 2 + 1}`;
                    }
                } else {
                    if (flyersBranch.data!.pages.length === 1) {
                        return `${flyersBranch.data!.pages.length}`
                    }
                    return `${flyersBranch.data!.pages.length - currentSlide}`
                }
            }
        }
    }


    const onKeyDownArrowsOnKeyBoardForContent = (e: KeyboardEvent) => {
        const target = e.target as Element;
        if (target.nodeName.toLowerCase() !== 'input' && isVerticalScrolling) {
            if (e.key === 'End' || e.key === 'Home') {
                resetZooming();
            }
        }
    }

    const renderContent = () => {
        return (

            <Box
                tabIndex={0}
                className={flyers?.backgroundColorRgb? classes.backgroundColor : classes.backgroundImage}
                sx={{
                    flex: `1 1 auto`,
                    overflow: `auto`,
                    margin: `${(showBasket || isHelpScreen || shareMenu.isOpen || showSearch || isTocOpen || (Boolean(selectedSpot.spot) && !selectedSpot.isExpanded)) && isVerticalScrolling ? (isHebrewStyle ? '0 0 0 430px' : '0 430px 0 0') : ''}`,
                }}
                onScroll={handleScroll}
                ref={flyerContentWrapper}
            >
                {pages && pages.length > 0 && isMultipage && !shelvesScreen.isOpen && (
                    <Box
                        id={`mainSliderWrapper`}
                        ref={contentFlyerPagesRef}
                    >
                        <SliderFor2Flyer
                            sliderRef={sliderRef}
                            handleSwipe={handleSwipe}
                            settings={settings}
                            calculateFlyerContainerHeightWidth={calculateFlyerContainerHeightWidth}
                            setPageRangeInUrl={setPageRangeInUrl}
                        />
                    </Box>
                )}
                <Suspense fallback={<></>}>
                    {showBasket && !shelvesScreen.isOpen &&
                        <Box className={classes.myListWrapper}>
                            {/*<Box className={`${styles.basketContainer} ${isHebrewStyle ? styles.hebrewStyle : ''}`}>*/}
                            <Basket/>
                        </Box>
                    }

                    {isHelpScreen && !shelvesScreen.isOpen &&
                        <HelpMenu isHebrewStyle={isHebrewStyle} showBasket={showBasket}/>
                    }
                    {shareMenu.isOpen && !shelvesScreen.isOpen &&
                        <ShareMenu isHebrewStyle={isHebrewStyle}/>
                    }
                    {isTocOpen && !shelvesScreen.isOpen &&
                        <TocMenu isHebrewStyle={isHebrewStyle} totalFlyerPages={flyers!.pages!.length}
                                 showBasket={showBasket} sliderRef={sliderRef}
                        />
                    }
                    {showSearch && !shelvesScreen.isOpen &&
                        <SearchMenu totalFlyerPages={flyers!.pages!.length}
                                    isHebrewStyle={isHebrewStyle} sliderRef={sliderRef}
                        />
                        // <Search/>
                    }

                    {
                        !shelvesScreen.isOpen &&
                        <>
                            <AddToBasket/>
                            <AddToMyListOneItemPopupWrapper/>
                            <ContactUsFormWrapper/>
                            <FreeFlipbookModal/>
                            <Checkout/>
                            <FrameClickPopup/>
                        </>
                    }

                    <ProductDetails/>
                    <ContactUsSuccessPopup isOpen={isSuccessPopupShow} onClose={() => {
                        showSuccessPopup(false)
                    }}/>
                    <FeedbackModal/>
                    <ProgressBarPopup/>
                </Suspense>
                <ShelvesScreen/>
            </Box>
        );
    }

    return (
        <>
            <Box sx={{
                display: 'flex',
                flexFlow: 'column',
                overflow: 'hidden',
                height: `${document.documentElement.clientHeight}px`
            }}>
                <Box sx={{flex: `0 1 50px`}}>
                    <ShopperHeader
                        openFullScreen={openFullScreen}
                        sliderRef={sliderRef}
                        setPageRangeInUrl={setPageRangeInUrl}
                    />
                </Box>
                <Tooltip
                    enterDelay={1000}
                    enterNextDelay={1000}
                    title={<PowerByTooltipContent/>}
                    placement={"top-end"}
                    TransitionComponent={Zoom}
                    // title={frame.tooltip ? frame.tooltip : ``}
                    arrow={true}
                >
                    <Box className={classes.powerByWrapper}
                         sx={{
                             left: isHebrewStyle ? `auto` : `30px`,
                             right: isHebrewStyle ? `30px` : `auto`,
                         }}
                    > <Suspense fallback={<></>}>
                        <PoweredBy/>
                    </Suspense>
                    </Box>
                </Tooltip>
                {renderContent()}
            </Box>
        </>
    )
}

export default DesktopView;